/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { RECEIVED_INTRADAY_PRICING_MANUAL} from 'state/Actions';
import { addToast } from 'state/toast/ToastActions';

const IntradayRefreshLogic = createLogic({
  type: RECEIVED_INTRADAY_PRICING_MANUAL,

  // eslint-disable-next-line no-unused-vars
  process({ action }, dispatch, done) {
    dispatch(
        addToast(
            true,
            'Your total portfolio and brokerage account(s) have been updated!'
        )
    );

    done();
  }
});

export default IntradayRefreshLogic;
